import { Link } from 'react-router-dom';
import { ROUTES } from '@/shared/config/routes';
import { SITE } from '@/shared/config/site';

export function SiteFooter() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-5 px-6 py-7">
        <Link
          to={ROUTES.home}
          className="font-display text-lg font-black italic text-foreground transition-colors hover:text-amber-500"
        >
          {SITE.name}
        </Link>
        <div className="flex flex-wrap items-center gap-5">
          <Link
            to={ROUTES.home}
            className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground transition-colors hover:text-foreground"
          >
            Articles
          </Link>
          <Link
            to={ROUTES.about}
            className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground transition-colors hover:text-foreground"
          >
            About
          </Link>
          {/*
            A crawlable link to the feed. Feed discovery is also declared in
            index.html, but readers who look for a visible link find one here.
          */}
          <a
            href="/rss.xml"
            className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground transition-colors hover:text-foreground"
          >
            RSS
          </a>
          <span className="font-mono text-[10px] text-border">—</span>
          <span className="font-mono text-[10px] text-muted-foreground">
            © {new Date().getFullYear()} {SITE.name}
          </span>
        </div>
      </div>
    </footer>
  );
}
